<template>
    <div class="marquee">
        <div class="desktop-marquee">
            <ul class="marquee-content">
                <li
                    class="marquee-item"
                    v-for="(partner, index) in partners"
                    :key="`partner-${index}`"
                >
                    <img :src="partner.image" :alt="`partner-${index}`" />
                </li>
            </ul>
        </div>
        <div class="mobile-marquee">
            <ul class="marquee-content">
                <li
                    class="marquee-item"
                    v-for="(partner, index) in mobilePartnersFirst"
                    :key="`partner-${index}`"
                >
                    <img :src="partner.image" :alt="`partner-${index}`" />
                </li>
            </ul>
            <ul class="marquee-content marquee-second">
                <li
                    class="marquee-item"
                    v-for="(partner, index) in mobilePartnersSecond"
                    :key="`partner-${index}`"
                >
                    <img :src="partner.image" :alt="`partner-${index}`" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // Pleaase update the CSS below to match the animation length
            partners: [
                {
                    image: "/images/landing-page/partners/3ac.png"
                },
                {
                    image: "/images/landing-page/partners/Algo Foundation.png"
                },
                {
                    image: "/images/landing-page/partners/Avocado Guild.png"
                },
                {
                    image:
                        "/images/landing-page/partners/borderless capital.png"
                },
                {
                    image: "/images/landing-page/partners/bybit-mirana.png"
                },
                {
                    image: "/images/landing-page/partners/Comma Ventures.png"
                },
                {
                    image: "/images/landing-page/partners/crypto-logo.png"
                },
                {
                    image:
                        "/images/landing-page/partners/DeFi Capital standard.jpg"
                },
                {
                    image:
                        "/images/landing-page/partners/Deribit_Company_Logo 1.png"
                },
                {
                    image: "/images/landing-page/partners/genesis-trading.png"
                },
                {
                    image: "/images/landing-page/partners/Global Foundation.png"
                },
                {
                    image: "/images/landing-page/partners/GoldenTree.png"
                },
                {
                    image: "/images/landing-page/partners/GSR.png"
                },
                {
                    image:
                        "/images/landing-page/partners/Hyperchain Capital.png"
                },
                {
                    image: "/images/landing-page/partners/JumpCrypto.png"
                },
                {
                    image: "/images/landing-page/partners/ledgerprime.png"
                },
                {
                    image: "/images/landing-page/partners/MEXC.png"
                },
                {
                    image: "/images/landing-page/partners/paradigm otc.png"
                },
                {
                    image:
                        "/images/landing-page/partners/QCP-Logo-Horizontal-1.png"
                },
                {
                    image: "/images/landing-page/partners/Raptor Capital.png"
                },
                {
                    image: "/images/landing-page/partners/tribe-logo.png"
                },
                {
                    image: "/images/landing-page/partners/Wintermute.png"
                },
                {
                    image: "/images/landing-page/partners/Woo DAO.png"
                },

                // Repeat 10 elements
                {
                    image: "/images/landing-page/partners/3ac.png"
                },
                {
                    image: "/images/landing-page/partners/Algo Foundation.png"
                },
                {
                    image: "/images/landing-page/partners/Avocado Guild.png"
                },
                {
                    image:
                        "/images/landing-page/partners/borderless capital.png"
                },
                {
                    image: "/images/landing-page/partners/bybit-mirana.png"
                },
                {
                    image: "/images/landing-page/partners/Comma Ventures.png"
                },
                {
                    image: "/images/landing-page/partners/Crypto dot com.png"
                },
                {
                    image:
                        "/images/landing-page/partners/DeFi Capital standard.jpg"
                },
                {
                    image:
                        "/images/landing-page/partners/Deribit_Company_Logo 1.png"
                },
                {
                    image: "/images/landing-page/partners/genesis-trading.png"
                }
            ]
        };
    },
    computed: {
        mobilePartnersFirst() {
            return this.partners.slice(0, 12).concat(this.partners.slice(0, 5));
        },
        mobilePartnersSecond() {
            return this.partners
                .slice(12, 23)
                .concat(this.partners.slice(12, 17));
        }
    },
    mounted() {
        console.log(this.mobilePartnersSecond);
    }
};
</script>

<style lang="scss" scoped>
.marquee {
    width: 100vw;
    max-width: 100%;
    padding: 15px 0;
    overflow: hidden;
    background: white;

    .desktop-marquee {
        display: none;

        @media only screen and (min-width: 768px) {
            display: block;
        }
    }
    .mobile-marquee {
        display: flex;
        flex-direction: column;
        gap: 15px;

        @media only screen and (min-width: 768px) {
            display: none;
        }

        .marquee-content {
            animation: scrollingMobileFirst 80s linear infinite;

            &.marquee-second {
                animation: scrollingMobileSecond 80s linear infinite;
            }
        }
    }
}

.marquee-content {
    display: flex;
    list-style: none;
    animation: scrolling 100s linear infinite;
    padding: 0;
    margin: 0;
}

.marquee-item {
    max-width: 200px;
    width: auto;
    height: 52px;
    flex-shrink: 0;
    margin: 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        max-height: 100%;
    }
}

.marquee-image {
    height: 100%;
    width: 100%;
}

@keyframes scrolling {
    0% {
        transform: translateX(0);
    }
    100% {
        // The formula is 280 * n
        // n is the TOTAL of the showed images
        // NOT THE TOTAL OF THE LIST !!!

        // transform: translatex(-1400px);
        // transform: translatex(-6440px);
        // transform: translatex(-5761px);
        transform: translatex(-5918px);
    }
}
@keyframes scrollingMobileFirst {
    0% {
        transform: translateX(0);
    }
    100% {
        // The formula is 280 * n
        // n is the TOTAL of the showed images
        // NOT THE TOTAL OF THE LIST !!!

        // transform: translatex(-1400px);
        // transform: translatex(-6440px);
        transform: translatex(-2976px);
    }
}
@keyframes scrollingMobileSecond {
    0% {
        transform: translateX(0);
    }
    100% {
        // The formula is 280 * n
        // n is the TOTAL of the showed images
        // NOT THE TOTAL OF THE LIST !!!

        // transform: translatex(-1400px);
        // transform: translatex(-6440px);
        // transform: translatex(-2786px);
        transform: translatex(-2942px);
    }
}
</style>
